<template>
  <div class="column content-box bg_white full_page">
    <woot-button
      v-if="buttonText"
      color-scheme="primary"
      :class-names="isMobile ? '' : 'button--fixed-right-top'"
      icon="add-circle"
      @click="openAddPopup"
    >
      {{ buttonText }}
    </woot-button>
    <campaign v-if="currentPath.includes('one_off')" />
    <email-template v-if="currentPath.includes('email_templates')" />
    <AddCampaignByStep v-if="currentPath.includes('add_campaign')" />
    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <add-campaign
        :initial-filter-types="contactFilterItems"
        @on-close="hideAddPopup"
      />
    </woot-modal>

    <!-- make a new page to add campaign. and keep the modal to show summery before submit -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import campaignMixin from 'shared/mixins/campaignMixin';
import Campaign from './Campaign.vue';
import AddCampaign from './AddCampaign';
import EmailTemplate from './EmailTemplates/Index.vue';
import contactFilterItems from '../../contacts/contactFilterItems';
import AddCampaignByStep from "./AddCampaignByStep.vue"
import responsiveMixin from 'shared/mixins/responsiveMixin.js';

export default {
  components: {
    Campaign,
    AddCampaign,
    EmailTemplate,
    AddCampaignByStep,
  },
  mixins: [campaignMixin,responsiveMixin],
  data() {
    return {
      showAddPopup: false,
      contactFilterItems: contactFilterItems.map(filter => ({
        ...filter,
        attributeName: this.$t(
          `CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    buttonText() {
      if (this.isOngoingType) {
        return this.$t('CAMPAIGN.HEADER_BTN_TXT.ONGOING');
      } else if (this.isOnOffType) {
        return this.$t('CAMPAIGN.HEADER_BTN_TXT.ONE_OFF');
      } else {
        // return this.$t('CAMPAIGN.HEADER_BTN_TXT.EMAIL_TEMPLATES');
      }
    },
    currentPath() {
      return this.$route.path;
    }
  },
  mounted() {
    // this.$store.dispatch('campaigns/get');
    this.$store.dispatch('campaigns/getPageByCampaigns',{page:1});
  },
  methods: {
    openAddPopup() {
      // this.showAddPopup = true;
      // insted of show popup, navigate to stepby page
      this.$router.push(`/app/accounts/${this.currentUser.account_id}/campaigns/add_campaign`)
    },
    hideAddPopup() {
      // window.location.reload();
      this.showAddPopup = false;
    },
  },
};
</script>

<style scoped>
.bg_white{
  background-color: #fff;
}
</style>